(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');

    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';

    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.setHeaderHeight();

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener(
      'preventHeaderReveal',
      this.hideHeaderOnScrollUp
    );

    window.addEventListener(
      'scroll',
      this.onScrollHandler,
      false
    );

    this.mediaQuery = window.matchMedia('(max-width: 990px)');
    this.heightHandler = this.setHeaderHeight.bind(this);

    this.mediaQuery.addEventListener(
      'change',
      this.heightHandler
    );

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add(
        'shopify-section-header-sticky'
      );
    }

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty(
      '--header-height',
      `${this.header.offsetHeight}px`
    );
  }

  disconnectedCallback() {
    this.removeEventListener(
      'preventHeaderReveal',
      this.hideHeaderOnScrollUp
    );

    window.removeEventListener(
      'scroll',
      this.onScrollHandler
    );

    this.mediaQuery.removeEventListener(
      'change',
      this.heightHandler
    );
  }

  createObserver() {
    const observer = new IntersectionObserver((entries) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop;

    /* NEVER hide header while search is open */
    const searchOpen =
      this.querySelector('.header__search details[open]');

    if (searchOpen) {
      this.header.classList.remove(
        'shopify-section-header-hidden'
      );

      this.header.classList.add(
        'shopify-section-header-sticky'
      );

      this.currentScrollTop = scrollTop;
      return;
    }

    if (
      this.predictiveSearch &&
      this.predictiveSearch.isOpen
    ) {
      this.currentScrollTop = scrollTop;
      return;
    }

    const headerBottom =
      this.headerBounds.bottom ||
      this.header.offsetHeight;

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > headerBottom
    ) {
      this.header.classList.add(
        'scrolled-past-header'
      );

      requestAnimationFrame(
        this.hide.bind(this)
      );
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > headerBottom
    ) {
      this.header.classList.add(
        'scrolled-past-header'
      );

      if (!this.preventReveal) {
        requestAnimationFrame(
          this.reveal.bind(this)
        );
      }
    } else if (
      scrollTop <= (this.headerBounds.top || 0)
    ) {
      this.header.classList.remove(
        'scrolled-past-header'
      );

      requestAnimationFrame(
        this.reset.bind(this)
      );
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;

    /* Do not close/hide while search is open */
    if (
      this.querySelector(
        '.header__search details[open]'
      )
    ) {
      return;
    }

    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky'
    );

    this.closeMenuDisclosure();
  }

  reveal() {
    this.header.classList.add(
      'shopify-section-header-sticky',
      'animate'
    );

    this.header.classList.remove(
      'shopify-section-header-hidden'
    );
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;

    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );
  }

  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures ||
      this.header.querySelectorAll('header-menu');

    this.disclosures.forEach((disclosure) =>
      disclosure.close()
    );
  }
}

if (!customElements.get('sticky-header')) {
  customElements.define(
    'sticky-header',
    StickyHeader
  );
}

  } catch(e) { console.error(e); }
})();
})();
